import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { UserBackend } from "src/app/backend/api/user.backend";
import { sntLog } from "src/app/common/logger";
import { sntNavigate } from "src/app/support/router";
import { lastValueFrom } from "rxjs";

const logger = sntLog("ProcessInviteGuard");

@Injectable()
export class ProcessInviteGuard {
  private readonly router = inject(Router);
  private readonly userBackend = inject(UserBackend);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.info("canActivate");
    logger.info(state.url);

    const inviteId = route.queryParamMap.get("invite");

    if (!inviteId) {
      return true;
    }

    const url = new URL(`${location.origin}${state.url}`);
    url.searchParams.delete("invite");
    url.searchParams.delete("email");

    const returnUrl = `${url.pathname}${url.search}`;

    try {
      await lastValueFrom(this.userBackend.acceptInvite(inviteId));

      sntNavigate(this.router, [`invite`, inviteId, "accepted"], {
        queryParams: {
          returnUrl
        }
      });
    } catch (ex) {
      const httpErrorResponse = ex as HttpErrorResponse;

      // l'invito è già stato accettato in precedenza e faccio entrare direttamente l'utente
      if (httpErrorResponse.status === 409) {
        this.router.navigateByUrl(returnUrl, { replaceUrl: true });
        return false;
      }

      if (httpErrorResponse.status === 410) {
        sntNavigate(this.router, [`invite`, inviteId, "failed"], {
          queryParams: {
            returnUrl,
            httpStatus: 410
          }
        });

        return false;
      }

      sntNavigate(this.router, [`invite`, inviteId, "failed"], {
        queryParams: {
          returnUrl,
          httpStatus: httpErrorResponse.status
        }
      });
    }

    return false;
  }
}
